import { memo, useContext } from 'react';
import styled from '@emotion/styled';
import { AppThemingContext } from '@trinity/chat-components/containers/AppTheming/Context.js';
import { shouldForwardProp } from '@trinity/chat-components/utils/emotion';
import styles from './style/AnalysesList.Item.module.css';

type PanelItemProps = {
  className?: string;
  onSelect: () => void;
  selected: boolean;
  name: string;
};

export const QuantAnalysesPanelItem = memo(({
  className,
  onSelect,
  selected,
  name,
}: PanelItemProps) => {
  const theming = useContext(AppThemingContext);
  const enabled = theming?.theme?.enabled;

  const selectedBackgroundColor = enabled ? theming?.palette?.primary?.light : 'var(--blue-l)';
  const selectedTextColor = enabled ? theming?.palette?.primary?.main : 'var(--black-l)';

  return (
    <Root
      className={className}
      onClick={onSelect}
      selected={selected}
      selectedBackgroundColor={selectedBackgroundColor}
      selectedTextColor={selectedTextColor}>
      <div className={styles.wrap}>
        <div>{name}</div>
      </div>
    </Root>
  );
});

type RootProps = {
  selected?: boolean;
  selectedBackgroundColor?: string;
  selectedTextColor?: string;
};

const Root = styled('div', {
  shouldForwardProp: shouldForwardProp('selected', 'selectedBackgroundColor', 'selectedTextColor'),
})<RootProps>(({ selected, selectedBackgroundColor, selectedTextColor }) => ({
  cursor: 'pointer',
  borderBottom: '1px solid var(--gray-l)',
  backgroundColor: selected
    ? selectedBackgroundColor || 'var(--blue-l)'
    : undefined,
  color: selected
    ? selectedTextColor || 'var(--hyperlink)'
    : 'var(--black-l)',
}));
